import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CommonService } from '@app/shared/common/common.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { AppState } from '@app/app.service';
@Injectable()
export class AuthGuard implements CanActivate {
  routerPermission: any;
  cookieExistValue: any;
  constructor(private appService : AppState,private commonService:CommonService,private router: Router ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
    // let cookieExist = this.commonService.getCookie(environment.loginCookie);
    // console.log(cookieExist,'-------------cookieExist')
    let cookieExist  = "";
    // console.log(this.commonService.encryptionKey);
    
    if(this.commonService.getCookie(environment.loginCookie)) {
      cookieExist  = this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.loginCookie)));
      this.cookieExistValue =  JSON.parse(cookieExist);
    }
    
    if (cookieExist == "") {
      // let instance = localStorage.getEncryptedItem("insatnce") ? localStorage.getEncryptedItem("insatnce") : 'hilcona'
      // window.location.href = 'https://'+instance+environment.logout_url;
      console.log(state.url);
      
      if (state.url == '/unauthorized')
        return true;
      else{
        this.router.navigate(['/unauthorized'])
        return false;
      }
        
    }
    else {
      if(!localStorage.getEncryptedItem("userRights")) {
        var formData = new FormData();
        formData.append("instanceId", localStorage.getEncryptedItem('instanceId'))
        formData.append("companyUserId", this.cookieExistValue['companyUserId'])
        formData.append('userId',this.cookieExistValue['userId']);
        formData.append("loggedInTime", this.cookieExistValue['loggedInTime']);
        formData.append("lastRequestTime",localStorage.getEncryptedItem("lastRequestTime"));
        let object = this.commonService.createObject(formData)
        let token = this.commonService.createToken(object)
        let encryptedToken = this.commonService.encrypt(token)
        let encrData  = new FormData()
        encrData .append("encrToken", encryptedToken);      
        this.appService.getUserRights(encrData).subscribe(res => { 
          if(res['STATUS']) {
            localStorage.setEncryptedItem("lastRequestTime", res['RESPONSETIME']);
            let right = String(res['DATA']);
            if(res['DATA']==""){
              this.logout();
            }       
            localStorage.setEncryptedItem("userRights", right); 
            this.router.navigateByUrl(state.url);
          }
          else {
            this.logout();
          }
          // window.location.href = environment.WEB_URL.slice(0, -1)+state.url;
        })
        
      }
      else {
        // const right = route.data.right;
        // let rights = localStorage.getEncryptedItem('userRights');
        // let rightsArray = rights.split(',')
        // if(rightsArray.includes(right))
        //   return rightsArray.includes(right); 
        // else {
        //   window.location.reload();
        // } 
        return true;
      }
    }
  }

  logout() {
    console.log('aaaaa')
    let instance = localStorage.getEncryptedItem('instance');
    localStorage.clear();
    instance ?  window.location.href = 'https://'+instance+environment.logout_url: this.router.navigate(['/unauthorized']);
  }
  
}
